/* eslint-disable prettier/prettier */
export const config = {
  apiUrl:
    !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
      ? 'https://localhost:44385/'
      : 'https://api.ewangelibus.pl/',
  apiAdminUrl:
    !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
      ? 'https://localhost:44385/admin/'
      : 'https://api.ewangelibus.pl/admin/',
  filesUrl: 'https://images.ewangelibus.pl/',
  googleKey: 'AIzaSyCVLLCQpEJZvwAGB6o8gqHpzyl-vPZOGMo'
};
